// This file is auto-generated by @hey-api/openapi-ts

import {
  createClient,
  createConfig,
  type Options,
  formDataBodySerializer,
} from '@hey-api/client-fetch';
import {
  type GlacierUsersApiListUsersError,
  type GlacierUsersApiListUsersResponse,
  type GlacierUsersApiCurrentUserError,
  type GlacierUsersApiCurrentUserResponse,
  type GlacierUsersApiRelatedUsersError,
  type GlacierUsersApiRelatedUsersResponse,
  type GlacierUsersApiUnderwritersError,
  type GlacierUsersApiUnderwritersResponse,
  type GlacierUsersApiForgotPasswordEndpointData,
  type GlacierUsersApiForgotPasswordEndpointError,
  type GlacierUsersApiForgotPasswordEndpointResponse,
  type GlacierUsersApiResetPasswordEndpointData,
  type GlacierUsersApiResetPasswordEndpointError,
  type GlacierUsersApiResetPasswordEndpointResponse,
  type GlacierPolicyApiListPoliciesError,
  type GlacierPolicyApiListPoliciesResponse,
  type GlacierPolicyApiCreatePolicyData,
  type GlacierPolicyApiCreatePolicyError,
  type GlacierPolicyApiCreatePolicyResponse,
  type GlacierPolicyApiGetPolicySummaryError,
  type GlacierPolicyApiGetPolicySummaryResponse,
  type GlacierPolicyApiGetPrintQueueData,
  type GlacierPolicyApiGetPrintQueueError,
  type GlacierPolicyApiGetPrintQueueResponse,
  type GlacierPolicyApiDeletePrintQueueData,
  type GlacierPolicyApiDeletePrintQueueError,
  type GlacierPolicyApiDeletePrintQueueResponse,
  type GlacierPolicyApiPrintQueueData,
  type GlacierPolicyApiPrintQueueError,
  type GlacierPolicyApiPrintQueueResponse,
  type GlacierPolicyApiGetPolicyData,
  type GlacierPolicyApiGetPolicyError,
  type GlacierPolicyApiGetPolicyResponse,
  type GlacierPolicyApiGetLatestTransactionSummaryData,
  type GlacierPolicyApiGetLatestTransactionSummaryError,
  type GlacierPolicyApiGetLatestTransactionSummaryResponse,
  type GlacierPolicyApiGetLatestTransactionLatestAttemptData,
  type GlacierPolicyApiGetLatestTransactionLatestAttemptError,
  type GlacierPolicyApiGetLatestTransactionLatestAttemptResponse,
  type GlacierPolicyApiValidatePolicyFieldsData,
  type GlacierPolicyApiValidatePolicyFieldsError,
  type GlacierPolicyApiValidatePolicyFieldsResponse,
  type GlacierPolicyApiAssignAgentData,
  type GlacierPolicyApiAssignAgentError,
  type GlacierPolicyApiAssignAgentResponse,
  type GlacierPolicyApiAssignUnderwriterData,
  type GlacierPolicyApiAssignUnderwriterError,
  type GlacierPolicyApiAssignUnderwriterResponse,
  type GlacierPolicyApiAssignData,
  type GlacierPolicyApiAssignError,
  type GlacierPolicyApiAssignResponse,
  type GlacierPolicyApiAssignableData,
  type GlacierPolicyApiAssignableError,
  type GlacierPolicyApiAssignableResponse,
  type GlacierPolicyApiGetPolicyWithSummariesData,
  type GlacierPolicyApiGetPolicyWithSummariesError,
  type GlacierPolicyApiGetPolicyWithSummariesResponse,
  type GlacierPolicyApiGetPolicyPermissionsData,
  type GlacierPolicyApiGetPolicyPermissionsError,
  type GlacierPolicyApiGetPolicyPermissionsResponse,
  type GlacierPolicyApiDeclineTransactionData,
  type GlacierPolicyApiDeclineTransactionError,
  type GlacierPolicyApiDeclineTransactionResponse,
  type GlacierPolicyApiDiscardTransactionData,
  type GlacierPolicyApiDiscardTransactionError,
  type GlacierPolicyApiDiscardTransactionResponse,
  type GlacierPolicyApiReopenTransactionData,
  type GlacierPolicyApiReopenTransactionError,
  type GlacierPolicyApiReopenTransactionResponse,
  type GlacierPolicyApiAddLocationData,
  type GlacierPolicyApiAddLocationError,
  type GlacierPolicyApiAddLocationResponse,
  type GlacierPolicyApiUpdatePrimaryLocationData,
  type GlacierPolicyApiUpdatePrimaryLocationError,
  type GlacierPolicyApiUpdatePrimaryLocationResponse,
  type GlacierPolicyApiGetLocationData,
  type GlacierPolicyApiGetLocationError,
  type GlacierPolicyApiGetLocationResponse,
  type GlacierPolicyApiUpdateLocationData,
  type GlacierPolicyApiUpdateLocationError,
  type GlacierPolicyApiUpdateLocationResponse,
  type GlacierPolicyApiDeleteLocationData,
  type GlacierPolicyApiDeleteLocationError,
  type GlacierPolicyApiDeleteLocationResponse,
  type GlacierPolicyApiBulkUpdateLocationsData,
  type GlacierPolicyApiBulkUpdateLocationsError,
  type GlacierPolicyApiBulkUpdateLocationsResponse,
  type GlacierPolicyApiUndoDeleteLocationData,
  type GlacierPolicyApiUndoDeleteLocationError,
  type GlacierPolicyApiUndoDeleteLocationResponse,
  type GlacierPolicyApiGetDentistData,
  type GlacierPolicyApiGetDentistError,
  type GlacierPolicyApiGetDentistResponse,
  type GlacierPolicyApiSetDentistAsFirstNamedInsuredData,
  type GlacierPolicyApiSetDentistAsFirstNamedInsuredError,
  type GlacierPolicyApiSetDentistAsFirstNamedInsuredResponse,
  type GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredData,
  type GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredError,
  type GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredResponse,
  type GlacierPolicyApiAddDentistData,
  type GlacierPolicyApiAddDentistError,
  type GlacierPolicyApiAddDentistResponse,
  type GlacierPolicyApiDeleteDentistData,
  type GlacierPolicyApiDeleteDentistError,
  type GlacierPolicyApiDeleteDentistResponse,
  type GlacierPolicyApiUpdateBasicDentistData,
  type GlacierPolicyApiUpdateBasicDentistError,
  type GlacierPolicyApiUpdateBasicDentistResponse,
  type GlacierPolicyApiUndoDeleteDentistData,
  type GlacierPolicyApiUndoDeleteDentistError,
  type GlacierPolicyApiUndoDeleteDentistResponse,
  type GlacierPolicyApiUpdateDentistInformationData,
  type GlacierPolicyApiUpdateDentistInformationError,
  type GlacierPolicyApiUpdateDentistInformationResponse,
  type GlacierPolicyApiGetDentistInformationData,
  type GlacierPolicyApiGetDentistInformationError,
  type GlacierPolicyApiGetDentistInformationResponse,
  type GlacierPolicyApiUpdateDentistPricingData,
  type GlacierPolicyApiUpdateDentistPricingError,
  type GlacierPolicyApiUpdateDentistPricingResponse,
  type GlacierPolicyApiGetDentistPricingData,
  type GlacierPolicyApiGetDentistPricingError,
  type GlacierPolicyApiGetDentistPricingResponse,
  type GlacierPolicyApiUpdateDentistProceduresData,
  type GlacierPolicyApiUpdateDentistProceduresError,
  type GlacierPolicyApiUpdateDentistProceduresResponse,
  type GlacierPolicyApiGetDentistProceduresData,
  type GlacierPolicyApiGetDentistProceduresError,
  type GlacierPolicyApiGetDentistProceduresResponse,
  type GlacierPolicyApiUpdatePlPracticeOwnerData,
  type GlacierPolicyApiUpdatePlPracticeOwnerError,
  type GlacierPolicyApiUpdatePlPracticeOwnerResponse,
  type GlacierPolicyApiGetPracticeOwnersData,
  type GlacierPolicyApiGetPracticeOwnersError,
  type GlacierPolicyApiGetPracticeOwnersResponse,
  type GlacierPolicyApiUpdatePlCoverageData,
  type GlacierPolicyApiUpdatePlCoverageError,
  type GlacierPolicyApiUpdatePlCoverageResponse,
  type GlacierPolicyApiGetPlCoverageData,
  type GlacierPolicyApiGetPlCoverageError,
  type GlacierPolicyApiGetPlCoverageResponse,
  type GlacierPolicyApiUpdatePolicyDetailsData,
  type GlacierPolicyApiUpdatePolicyDetailsError,
  type GlacierPolicyApiUpdatePolicyDetailsResponse,
  type GlacierPolicyApiGetPolicyDetailsData,
  type GlacierPolicyApiGetPolicyDetailsError,
  type GlacierPolicyApiGetPolicyDetailsResponse,
  type GlacierPolicyApiUpdateBypassValidatorsData,
  type GlacierPolicyApiUpdateBypassValidatorsError,
  type GlacierPolicyApiUpdateBypassValidatorsResponse,
  type GlacierPolicyApiRefreshCommercialPropertyWithVeriskData,
  type GlacierPolicyApiRefreshCommercialPropertyWithVeriskError,
  type GlacierPolicyApiRefreshCommercialPropertyWithVeriskResponse,
  type GlacierPolicyApiRefreshCommercialPropertyWithCorelogicData,
  type GlacierPolicyApiRefreshCommercialPropertyWithCorelogicError,
  type GlacierPolicyApiRefreshCommercialPropertyWithCorelogicResponse,
  type GlacierPolicyApiAddCommercialPropertyCoverageData,
  type GlacierPolicyApiAddCommercialPropertyCoverageError,
  type GlacierPolicyApiAddCommercialPropertyCoverageResponse,
  type GlacierPolicyApiUpdateCommercialPropertyCoverageData,
  type GlacierPolicyApiUpdateCommercialPropertyCoverageError,
  type GlacierPolicyApiUpdateCommercialPropertyCoverageResponse,
  type GlacierPolicyApiDeleteCommercialPropertyCoverageData,
  type GlacierPolicyApiDeleteCommercialPropertyCoverageError,
  type GlacierPolicyApiDeleteCommercialPropertyCoverageResponse,
  type GlacierPolicyApiGetCommercialPropertyLocationData,
  type GlacierPolicyApiGetCommercialPropertyLocationError,
  type GlacierPolicyApiGetCommercialPropertyLocationResponse,
  type GlacierPolicyApiUndoDeleteCommercialPropertyCoverageData,
  type GlacierPolicyApiUndoDeleteCommercialPropertyCoverageError,
  type GlacierPolicyApiUndoDeleteCommercialPropertyCoverageResponse,
  type GlacierPolicyApiUpdateCpCoverageData,
  type GlacierPolicyApiUpdateCpCoverageError,
  type GlacierPolicyApiUpdateCpCoverageResponse,
  type GlacierPolicyApiGetCommercialPropertyCoverageData,
  type GlacierPolicyApiGetCommercialPropertyCoverageError,
  type GlacierPolicyApiGetCommercialPropertyCoverageResponse,
  type GlacierPolicyApiRatePolicyData,
  type GlacierPolicyApiRatePolicyError,
  type GlacierPolicyApiRatePolicyResponse,
  type GlacierPolicyApiGetFormulasData,
  type GlacierPolicyApiGetFormulasError,
  type GlacierPolicyApiGetFormulasResponse,
  type GlacierPolicyApiCreateOwnedEntitiesData,
  type GlacierPolicyApiCreateOwnedEntitiesError,
  type GlacierPolicyApiCreateOwnedEntitiesResponse,
  type GlacierPolicyApiGetOwnedEntityData,
  type GlacierPolicyApiGetOwnedEntityError,
  type GlacierPolicyApiGetOwnedEntityResponse,
  type GlacierPolicyApiUpdatedOwnedEntityData,
  type GlacierPolicyApiUpdatedOwnedEntityError,
  type GlacierPolicyApiUpdatedOwnedEntityResponse,
  type GlacierPolicyApiDeleteOwnedEntityData,
  type GlacierPolicyApiDeleteOwnedEntityError,
  type GlacierPolicyApiDeleteOwnedEntityResponse,
  type GlacierPolicyApiUndoDeleteOwnedEntityData,
  type GlacierPolicyApiUndoDeleteOwnedEntityError,
  type GlacierPolicyApiUndoDeleteOwnedEntityResponse,
  type GlacierPolicyApiUpdateGeneralLiabilityData,
  type GlacierPolicyApiUpdateGeneralLiabilityError,
  type GlacierPolicyApiUpdateGeneralLiabilityResponse,
  type GlacierPolicyApiUpdateEmploymentPracticesLiabilityData,
  type GlacierPolicyApiUpdateEmploymentPracticesLiabilityError,
  type GlacierPolicyApiUpdateEmploymentPracticesLiabilityResponse,
  type GlacierPolicyApiUpdateErisaAndEmployeeBenefitsData,
  type GlacierPolicyApiUpdateErisaAndEmployeeBenefitsError,
  type GlacierPolicyApiUpdateErisaAndEmployeeBenefitsResponse,
  type GlacierPolicyApiIssuePolicyData,
  type GlacierPolicyApiIssuePolicyError,
  type GlacierPolicyApiIssuePolicyResponse,
  type GlacierPolicyApiGetAgentAuthorityData,
  type GlacierPolicyApiGetAgentAuthorityError,
  type GlacierPolicyApiGetAgentAuthorityResponse,
  type GlacierPolicyApiCreateMidtermTransactionData,
  type GlacierPolicyApiCreateMidtermTransactionError,
  type GlacierPolicyApiCreateMidtermTransactionResponse,
  type GlacierPolicyApiSetReasonForChangeData,
  type GlacierPolicyApiSetReasonForChangeError,
  type GlacierPolicyApiSetReasonForChangeResponse,
  type GlacierPolicyApiPricePreviewMidtermChangeData,
  type GlacierPolicyApiPricePreviewMidtermChangeError,
  type GlacierPolicyApiPricePreviewMidtermChangeResponse,
  type GlacierPolicyApiFinalizeMidtermChangeData,
  type GlacierPolicyApiFinalizeMidtermChangeError,
  type GlacierPolicyApiFinalizeMidtermChangeResponse,
  type GlacierPolicyApiCancelMidtermChangeData,
  type GlacierPolicyApiCancelMidtermChangeError,
  type GlacierPolicyApiCancelMidtermChangeResponse,
  type GlacierPolicyApiRevertTransactionData,
  type GlacierPolicyApiRevertTransactionError,
  type GlacierPolicyApiRevertTransactionResponse,
  type GlacierPolicyApiUpdateDentistUnderwritingQuestionsData,
  type GlacierPolicyApiUpdateDentistUnderwritingQuestionsError,
  type GlacierPolicyApiUpdateDentistUnderwritingQuestionsResponse,
  type GlacierPolicyApiPremiumStatementData,
  type GlacierPolicyApiPremiumStatementError,
  type GlacierPolicyApiPremiumStatementResponse,
  type GlacierPolicyApiGetSpecialFormsData,
  type GlacierPolicyApiGetSpecialFormsError,
  type GlacierPolicyApiGetSpecialFormsResponse,
  type GlacierPolicyApiConditionalRenewalNoticeData,
  type GlacierPolicyApiConditionalRenewalNoticeError,
  type GlacierPolicyApiConditionalRenewalNoticeResponse,
  type GlacierPolicyApiDownloadRatingWorksheetsData,
  type GlacierPolicyApiDownloadRatingWorksheetsError,
  type GlacierPolicyApiDownloadRatingWorksheetsResponse,
  type GlacierPolicyApiPremiumRenewalNoticeData,
  type GlacierPolicyApiPremiumRenewalNoticeError,
  type GlacierPolicyApiPremiumRenewalNoticeResponse,
  type GlacierPolicyApiDownloadLookerDashboardPdfData,
  type GlacierPolicyApiDownloadLookerDashboardPdfError,
  type GlacierPolicyApiDownloadLookerDashboardPdfResponse,
  type GlacierPolicyApiDownloadLookerDashboardCsvData,
  type GlacierPolicyApiDownloadLookerDashboardCsvError,
  type GlacierPolicyApiDownloadLookerDashboardCsvResponse,
  type GlacierPolicyApiSpecimenPreviewData,
  type GlacierPolicyApiSpecimenPreviewError,
  type GlacierPolicyApiSpecimenPreviewResponse,
  type GlacierPolicyApiListDocumentsData,
  type GlacierPolicyApiListDocumentsError,
  type GlacierPolicyApiListDocumentsResponse,
  type GlacierPolicyApiUploadDocumentData,
  type GlacierPolicyApiUploadDocumentError,
  type GlacierPolicyApiUploadDocumentResponse,
  type GlacierPolicyApiDetachDocumentData,
  type GlacierPolicyApiDetachDocumentError,
  type GlacierPolicyApiDetachDocumentResponse,
  type GlacierPolicyApiUpdateDocumentData,
  type GlacierPolicyApiUpdateDocumentError,
  type GlacierPolicyApiUpdateDocumentResponse,
  type DocumentIsReadyData,
  type DocumentIsReadyError,
  type DocumentIsReadyResponse,
  type GlacierPolicyApiDownloadDocumentData,
  type GlacierPolicyApiDownloadDocumentError,
  type GlacierPolicyApiDownloadDocumentResponse,
  type GlacierPolicyApiRegenerateDocumentData,
  type GlacierPolicyApiRegenerateDocumentError,
  type GlacierPolicyApiRegenerateDocumentResponse,
  type GlacierPolicyApiCommitTransactionTestData,
  type GlacierPolicyApiCommitTransactionTestError,
  type GlacierPolicyApiCommitTransactionTestResponse,
  type GlacierPolicyApiListUnderwriterNotesData,
  type GlacierPolicyApiListUnderwriterNotesError,
  type GlacierPolicyApiListUnderwriterNotesResponse,
  type GlacierPolicyApiCreateUnderwriterNotesData,
  type GlacierPolicyApiCreateUnderwriterNotesError,
  type GlacierPolicyApiCreateUnderwriterNotesResponse,
  type GlacierPolicyApiUpdateUnderwriterNotesData,
  type GlacierPolicyApiUpdateUnderwriterNotesError,
  type GlacierPolicyApiUpdateUnderwriterNotesResponse,
  type GlacierPolicyApiDeleteUnderwriterNotesData,
  type GlacierPolicyApiDeleteUnderwriterNotesError,
  type GlacierPolicyApiDeleteUnderwriterNotesResponse,
  type GlacierPolicyApiReopenUnlockedAccountData,
  type GlacierPolicyApiReopenUnlockedAccountError,
  type GlacierPolicyApiReopenUnlockedAccountResponse,
  type GlacierPolicyApiCreatePolicyPendingCancellationTransactionData,
  type GlacierPolicyApiCreatePolicyPendingCancellationTransactionError,
  type GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponse,
  type GlacierPolicyApiListObjectSummariesData,
  type GlacierPolicyApiListObjectSummariesError,
  type GlacierPolicyApiListObjectSummariesResponse,
  type GlacierPolicyApiGetObjectDetailsData,
  type GlacierPolicyApiGetObjectDetailsError,
  type GlacierPolicyApiGetObjectDetailsResponse,
  type GlacierPolicyApiReferPolicyData,
  type GlacierPolicyApiReferPolicyError,
  type GlacierPolicyApiReferPolicyResponse,
  type GlacierPolicyApiListTransactionsData,
  type GlacierPolicyApiListTransactionsError,
  type GlacierPolicyApiListTransactionsResponse,
  type GlacierPolicyApiGetTransactionDetailData,
  type GlacierPolicyApiGetTransactionDetailError,
  type GlacierPolicyApiGetTransactionDetailResponse,
  type GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsData,
  type GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsError,
  type GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsResponse,
  type GlacierPolicyFormsApiAttachFormToPolicyData,
  type GlacierPolicyFormsApiAttachFormToPolicyError,
  type GlacierPolicyFormsApiAttachFormToPolicyResponse,
  type GlacierPolicyFormsApiDetachFormFromPolicyData,
  type GlacierPolicyFormsApiDetachFormFromPolicyError,
  type GlacierPolicyFormsApiDetachFormFromPolicyResponse,
  type GlacierPolicyFormsApiGetAvailableEndorsementsData,
  type GlacierPolicyFormsApiGetAvailableEndorsementsError,
  type GlacierPolicyFormsApiGetAvailableEndorsementsResponse,
  type GlacierPolicyFormsApiAttachFormToDentistData,
  type GlacierPolicyFormsApiAttachFormToDentistError,
  type GlacierPolicyFormsApiAttachFormToDentistResponse,
  type GlacierPolicyFormsApiDetachFormFromDentistData,
  type GlacierPolicyFormsApiDetachFormFromDentistError,
  type GlacierPolicyFormsApiDetachFormFromDentistResponse,
  type GlacierPolicyFormsApiGetDentistAttachedFormsData,
  type GlacierPolicyFormsApiGetDentistAttachedFormsError,
  type GlacierPolicyFormsApiGetDentistAttachedFormsResponse,
  type GlacierPolicyFormsApiGetDentistAvailableEndorsementsData,
  type GlacierPolicyFormsApiGetDentistAvailableEndorsementsError,
  type GlacierPolicyFormsApiGetDentistAvailableEndorsementsResponse,
  type GlacierPolicyFormsApiAttachFormToLocationData,
  type GlacierPolicyFormsApiAttachFormToLocationError,
  type GlacierPolicyFormsApiAttachFormToLocationResponse,
  type GlacierPolicyFormsApiDetachFormFromLocationData,
  type GlacierPolicyFormsApiDetachFormFromLocationError,
  type GlacierPolicyFormsApiDetachFormFromLocationResponse,
  type GlacierPolicyFormsApiGetLocationAttachedFormsData,
  type GlacierPolicyFormsApiGetLocationAttachedFormsError,
  type GlacierPolicyFormsApiGetLocationAttachedFormsResponse,
  type GlacierPolicyFormsApiGetLocationAvailableEndorsementsData,
  type GlacierPolicyFormsApiGetLocationAvailableEndorsementsError,
  type GlacierPolicyFormsApiGetLocationAvailableEndorsementsResponse,
  type GlacierPolicyFormsApiAttachFormToEntityData,
  type GlacierPolicyFormsApiAttachFormToEntityError,
  type GlacierPolicyFormsApiAttachFormToEntityResponse,
  type GlacierPolicyFormsApiDetachFormFromEntityData,
  type GlacierPolicyFormsApiDetachFormFromEntityError,
  type GlacierPolicyFormsApiDetachFormFromEntityResponse,
  type GlacierPolicyFormsApiGetEntityAttachedFormsData,
  type GlacierPolicyFormsApiGetEntityAttachedFormsError,
  type GlacierPolicyFormsApiGetEntityAttachedFormsResponse,
  type GlacierPolicyFormsApiGetEntityAvailableEndorsementsData,
  type GlacierPolicyFormsApiGetEntityAvailableEndorsementsError,
  type GlacierPolicyFormsApiGetEntityAvailableEndorsementsResponse,
  type GlacierPolicyFormsApiRenderFormData,
  type GlacierPolicyFormsApiRenderFormError,
  type GlacierPolicyFormsApiRenderFormResponse,
  type GlacierPolicyFormsApiGetQuestionsByPolicyData,
  type GlacierPolicyFormsApiGetQuestionsByPolicyError,
  type GlacierPolicyFormsApiGetQuestionsByPolicyResponse,
  type GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyData,
  type GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyError,
  type GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyResponse,
  type GlacierPolicyFormsApiGetQuestionsByDentistData,
  type GlacierPolicyFormsApiGetQuestionsByDentistError,
  type GlacierPolicyFormsApiGetQuestionsByDentistResponse,
  type GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistData,
  type GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistError,
  type GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistResponse,
  type GlacierPolicyFormsApiGetQuestionsByLocationData,
  type GlacierPolicyFormsApiGetQuestionsByLocationError,
  type GlacierPolicyFormsApiGetQuestionsByLocationResponse,
  type GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationData,
  type GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationError,
  type GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationResponse,
  type GlacierPolicyFormsApiGetQuestionsByEntityData,
  type GlacierPolicyFormsApiGetQuestionsByEntityError,
  type GlacierPolicyFormsApiGetQuestionsByEntityResponse,
  type GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityData,
  type GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityError,
  type GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityResponse,
  type GlacierPolicyConditionsApiListBindingConditionsData,
  type GlacierPolicyConditionsApiListBindingConditionsError,
  type GlacierPolicyConditionsApiListBindingConditionsResponse,
  type GlacierPolicyConditionsApiCreateBindingConditionData,
  type GlacierPolicyConditionsApiCreateBindingConditionError,
  type GlacierPolicyConditionsApiCreateBindingConditionResponse,
  type GlacierPolicyConditionsApiUpdateBindingConditionData,
  type GlacierPolicyConditionsApiUpdateBindingConditionError,
  type GlacierPolicyConditionsApiUpdateBindingConditionResponse,
  type GlacierPolicyConditionsApiDeleteBindingConditionData,
  type GlacierPolicyConditionsApiDeleteBindingConditionError,
  type GlacierPolicyConditionsApiDeleteBindingConditionResponse,
  type GlacierPolicyConditionsApiListTermsConditionsData,
  type GlacierPolicyConditionsApiListTermsConditionsError,
  type GlacierPolicyConditionsApiListTermsConditionsResponse,
  type GlacierPolicyConditionsApiCreateTermsConditionData,
  type GlacierPolicyConditionsApiCreateTermsConditionError,
  type GlacierPolicyConditionsApiCreateTermsConditionResponse,
  type GlacierPolicyConditionsApiUpdateTermsConditionData,
  type GlacierPolicyConditionsApiUpdateTermsConditionError,
  type GlacierPolicyConditionsApiUpdateTermsConditionResponse,
  type GlacierPolicyConditionsApiDeleteTermsConditionData,
  type GlacierPolicyConditionsApiDeleteTermsConditionError,
  type GlacierPolicyConditionsApiDeleteTermsConditionResponse,
  type GlacierPolicyErpApiGetErpEligibleDatesData,
  type GlacierPolicyErpApiGetErpEligibleDatesError,
  type GlacierPolicyErpApiGetErpEligibleDatesResponse,
  type GlacierPolicyErpApiGetErpSectionsData,
  type GlacierPolicyErpApiGetErpSectionsError,
  type GlacierPolicyErpApiGetErpSectionsResponse,
  type GlacierPolicyErpApiStartErpEndorsementData,
  type GlacierPolicyErpApiStartErpEndorsementError,
  type GlacierPolicyErpApiStartErpEndorsementResponse,
  type GlacierPolicyErpApiSaveErpSelectionsData,
  type GlacierPolicyErpApiSaveErpSelectionsError,
  type GlacierPolicyErpApiSaveErpSelectionsResponse,
  type GlacierOneschemaApiGetJwtTokenError,
  type GlacierOneschemaApiGetJwtTokenResponse,
  type GlacierOneschemaApiBulkUploadPoliciesData,
  type GlacierOneschemaApiBulkUploadPoliciesError,
  type GlacierOneschemaApiBulkUploadPoliciesResponse,
  type GlacierOneschemaApiBulkUploadDentistsData,
  type GlacierOneschemaApiBulkUploadDentistsError,
  type GlacierOneschemaApiBulkUploadDentistsResponse,
  type GlacierOneschemaApiBulkUploadLocationsData,
  type GlacierOneschemaApiBulkUploadLocationsError,
  type GlacierOneschemaApiBulkUploadLocationsResponse,
  type GlacierAgenciesApiListWritingCompanyError,
  type GlacierAgenciesApiListWritingCompanyResponse,
  type GlacierNewGradApiValidateAgencyData,
  type GlacierNewGradApiValidateAgencyError,
  type GlacierNewGradApiValidateAgencyResponse,
  type GlacierNewGradApiSaveAnswersData,
  type GlacierNewGradApiSaveAnswersError,
  type GlacierNewGradApiSaveAnswersResponse,
  type GlacierNewGradApiGetAnswersData,
  type GlacierNewGradApiGetAnswersError,
  type GlacierNewGradApiGetAnswersResponse,
  type GlacierNewGradApiPollPaymentData,
  type GlacierNewGradApiPollPaymentError,
  type GlacierNewGradApiPollPaymentResponse,
  type GlacierNewGradApiDownloadQuoteData,
  type GlacierNewGradApiDownloadQuoteError,
  type GlacierNewGradApiDownloadQuoteResponse,
  type GlacierNewGradApiDownloadPolicyData,
  type GlacierNewGradApiDownloadPolicyError,
  type GlacierNewGradApiDownloadPolicyResponse,
  GlacierPolicyApiListPoliciesResponseTransformer,
  GlacierPolicyApiCreatePolicyResponseTransformer,
  GlacierPolicyApiValidatePolicyFieldsResponseTransformer,
  GlacierPolicyApiSetDentistAsFirstNamedInsuredResponseTransformer,
  GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredResponseTransformer,
  GlacierPolicyApiDeleteDentistResponseTransformer,
  GlacierPolicyApiUndoDeleteDentistResponseTransformer,
  GlacierPolicyApiRatePolicyResponseTransformer,
  GlacierPolicyApiGetFormulasResponseTransformer,
  GlacierPolicyApiDeleteOwnedEntityResponseTransformer,
  GlacierPolicyApiUndoDeleteOwnedEntityResponseTransformer,
  GlacierPolicyApiCreateMidtermTransactionResponseTransformer,
  GlacierPolicyApiPricePreviewMidtermChangeResponseTransformer,
  GlacierPolicyApiFinalizeMidtermChangeResponseTransformer,
  GlacierPolicyApiCancelMidtermChangeResponseTransformer,
  GlacierPolicyApiRevertTransactionResponseTransformer,
  GlacierPolicyApiListDocumentsResponseTransformer,
  GlacierPolicyApiListUnderwriterNotesResponseTransformer,
  GlacierPolicyApiCreateUnderwriterNotesResponseTransformer,
  GlacierPolicyApiUpdateUnderwriterNotesResponseTransformer,
  GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponseTransformer,
  GlacierPolicyApiListTransactionsResponseTransformer,
  GlacierPolicyApiGetTransactionDetailResponseTransformer,
  GlacierPolicyFormsApiAttachFormToPolicyResponseTransformer,
  GlacierPolicyFormsApiGetQuestionsByPolicyResponseTransformer,
  GlacierPolicyFormsApiGetQuestionsByDentistResponseTransformer,
  GlacierPolicyFormsApiGetQuestionsByLocationResponseTransformer,
  GlacierPolicyFormsApiGetQuestionsByEntityResponseTransformer,
  GlacierPolicyConditionsApiListBindingConditionsResponseTransformer,
  GlacierPolicyConditionsApiCreateBindingConditionResponseTransformer,
  GlacierPolicyConditionsApiUpdateBindingConditionResponseTransformer,
  GlacierPolicyConditionsApiListTermsConditionsResponseTransformer,
  GlacierPolicyConditionsApiCreateTermsConditionResponseTransformer,
  GlacierPolicyConditionsApiUpdateTermsConditionResponseTransformer,
  GlacierPolicyErpApiGetErpSectionsResponseTransformer,
  GlacierPolicyErpApiStartErpEndorsementResponseTransformer,
  GlacierPolicyErpApiSaveErpSelectionsResponseTransformer,
  GlacierNewGradApiSaveAnswersResponseTransformer,
  GlacierNewGradApiGetAnswersResponseTransformer,
} from './types.gen';

export const client = createClient(createConfig());

/**
 * List Users
 */
export const glacierUsersApiListUsers = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierUsersApiListUsersResponse,
    GlacierUsersApiListUsersError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/users/',
  });
};

/**
 * Current User
 */
export const glacierUsersApiCurrentUser = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierUsersApiCurrentUserResponse,
    GlacierUsersApiCurrentUserError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/users/current_user',
  });
};

/**
 * Related Users
 */
export const glacierUsersApiRelatedUsers = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierUsersApiRelatedUsersResponse,
    GlacierUsersApiRelatedUsersError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/users/related_users',
  });
};

/**
 * Underwriters
 */
export const glacierUsersApiUnderwriters = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierUsersApiUnderwritersResponse,
    GlacierUsersApiUnderwritersError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/users/underwriters',
  });
};

/**
 * Forgot Password Endpoint
 */
export const glacierUsersApiForgotPasswordEndpoint = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierUsersApiForgotPasswordEndpointData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierUsersApiForgotPasswordEndpointResponse,
    GlacierUsersApiForgotPasswordEndpointError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/users/forgot-password/',
  });
};

/**
 * Reset Password Endpoint
 */
export const glacierUsersApiResetPasswordEndpoint = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierUsersApiResetPasswordEndpointData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierUsersApiResetPasswordEndpointResponse,
    GlacierUsersApiResetPasswordEndpointError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/users/reset-password/',
  });
};

/**
 * List Policies
 */
export const glacierPolicyApiListPolicies = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiListPoliciesResponse,
    GlacierPolicyApiListPoliciesError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/',
    responseTransformer: GlacierPolicyApiListPoliciesResponseTransformer,
  });
};

/**
 * Create Policy
 */
export const glacierPolicyApiCreatePolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiCreatePolicyData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiCreatePolicyResponse,
    GlacierPolicyApiCreatePolicyError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/',
    responseTransformer: GlacierPolicyApiCreatePolicyResponseTransformer,
  });
};

/**
 * Get Policy Summary
 */
export const glacierPolicyApiGetPolicySummary = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetPolicySummaryResponse,
    GlacierPolicyApiGetPolicySummaryError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/summaries/',
  });
};

/**
 * Get Print Queue
 * Returns the list of policies that are visible to the print queue
 */
export const glacierPolicyApiGetPrintQueue = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GlacierPolicyApiGetPrintQueueData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetPrintQueueResponse,
    GlacierPolicyApiGetPrintQueueError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/print_queue/',
  });
};

/**
 * Delete Print Queue
 * Deletes a print queue item specified by `print_queue_id`.
 *
 * This function performs a soft delete operation on the print queue
 * by setting its 'deleted_at' attribute to the current timestamp.
 */
export const glacierPolicyApiDeletePrintQueue = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDeletePrintQueueData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    GlacierPolicyApiDeletePrintQueueResponse,
    GlacierPolicyApiDeletePrintQueueError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/print_queue/',
  });
};

/**
 * Print Queue
 * Starts a print queue for the given accounts, and return the zip file
 */
export const glacierPolicyApiPrintQueue = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiPrintQueueData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiPrintQueueResponse,
    GlacierPolicyApiPrintQueueError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/print_queue/',
  });
};

/**
 * Get Policy
 */
export const glacierPolicyApiGetPolicy = <ThrowOnError extends boolean = false>(
  options: Options<GlacierPolicyApiGetPolicyData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetPolicyResponse,
    GlacierPolicyApiGetPolicyError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/',
  });
};

/**
 * Get Latest Transaction Summary
 */
export const glacierPolicyApiGetLatestTransactionSummary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiGetLatestTransactionSummaryData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetLatestTransactionSummaryResponse,
    GlacierPolicyApiGetLatestTransactionSummaryError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/latest_transaction/summary',
  });
};

/**
 * Get Latest Transaction Latest Attempt
 */
export const glacierPolicyApiGetLatestTransactionLatestAttempt = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiGetLatestTransactionLatestAttemptData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetLatestTransactionLatestAttemptResponse,
    GlacierPolicyApiGetLatestTransactionLatestAttemptError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/latest_transaction/latest_attempt',
  });
};

/**
 * Validate Policy Fields
 * DEPRECATED: This endpoint uses the deprecated validators v1 system.
 * The validators v1 functionality has been removed. This endpoint
 * now returns an empty success response for API compatibility.
 * Please use validators v2 system instead.
 */
export const glacierPolicyApiValidatePolicyFields = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiValidatePolicyFieldsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiValidatePolicyFieldsResponse,
    GlacierPolicyApiValidatePolicyFieldsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/validate/',
    responseTransformer:
      GlacierPolicyApiValidatePolicyFieldsResponseTransformer,
  });
};

/**
 * Assign Agent
 */
export const glacierPolicyApiAssignAgent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiAssignAgentData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiAssignAgentResponse,
    GlacierPolicyApiAssignAgentError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/assign_agent/',
  });
};

/**
 * Assign Underwriter
 */
export const glacierPolicyApiAssignUnderwriter = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiAssignUnderwriterData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiAssignUnderwriterResponse,
    GlacierPolicyApiAssignUnderwriterError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/assign_underwriter/',
  });
};

/**
 * Assign
 */
export const glacierPolicyApiAssign = <ThrowOnError extends boolean = false>(
  options: Options<GlacierPolicyApiAssignData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiAssignResponse,
    GlacierPolicyApiAssignError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/assign/',
  });
};

/**
 * Assignable
 */
export const glacierPolicyApiAssignable = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiAssignableData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiAssignableResponse,
    GlacierPolicyApiAssignableError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/assignable/',
  });
};

/**
 * Get Policy With Summaries
 */
export const glacierPolicyApiGetPolicyWithSummaries = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetPolicyWithSummariesData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetPolicyWithSummariesResponse,
    GlacierPolicyApiGetPolicyWithSummariesError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/summaries/',
  });
};

/**
 * Get Policy Permissions
 */
export const glacierPolicyApiGetPolicyPermissions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetPolicyPermissionsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetPolicyPermissionsResponse,
    GlacierPolicyApiGetPolicyPermissionsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/permissions/',
  });
};

/**
 * Decline Transaction
 * This acts as DECLINE or NOT TAKEN if user is an Underwriter or Agent respectively
 */
export const glacierPolicyApiDeclineTransaction = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDeclineTransactionData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiDeclineTransactionResponse,
    GlacierPolicyApiDeclineTransactionError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/decline/',
  });
};

/**
 * Discard Transaction
 * Discards a transaction. A discarded transaction cannot be reopened
 */
export const glacierPolicyApiDiscardTransaction = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDiscardTransactionData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiDiscardTransactionResponse,
    GlacierPolicyApiDiscardTransactionError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/discard/',
  });
};

/**
 * Reopen Transaction
 * Reopens a transaction. Only transactions that are in DECLINED or NOT_TAKEN can be reopened
 */
export const glacierPolicyApiReopenTransaction = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiReopenTransactionData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiReopenTransactionResponse,
    GlacierPolicyApiReopenTransactionError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/reopen/',
  });
};

/**
 * Add Location
 */
export const glacierPolicyApiAddLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiAddLocationData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiAddLocationResponse,
    GlacierPolicyApiAddLocationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/location/',
  });
};

/**
 * Update Primary Location
 */
export const glacierPolicyApiUpdatePrimaryLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdatePrimaryLocationData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiUpdatePrimaryLocationResponse,
    GlacierPolicyApiUpdatePrimaryLocationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/location/primary/',
  });
};

/**
 * Get Location
 */
export const glacierPolicyApiGetLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetLocationData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetLocationResponse,
    GlacierPolicyApiGetLocationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/location/{location_id}/',
  });
};

/**
 * Update Location
 */
export const glacierPolicyApiUpdateLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateLocationData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    GlacierPolicyApiUpdateLocationResponse,
    GlacierPolicyApiUpdateLocationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/location/{location_id}/',
  });
};

/**
 * Delete Location
 */
export const glacierPolicyApiDeleteLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDeleteLocationData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    GlacierPolicyApiDeleteLocationResponse,
    GlacierPolicyApiDeleteLocationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/location/{location_id}/',
  });
};

/**
 * Bulk Update Locations
 */
export const glacierPolicyApiBulkUpdateLocations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiBulkUpdateLocationsData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    GlacierPolicyApiBulkUpdateLocationsResponse,
    GlacierPolicyApiBulkUpdateLocationsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/locations/',
  });
};

/**
 * Undo Delete Location
 */
export const glacierPolicyApiUndoDeleteLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUndoDeleteLocationData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiUndoDeleteLocationResponse,
    GlacierPolicyApiUndoDeleteLocationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/location/{location_id}/reinstate',
  });
};

/**
 * Get Dentist
 */
export const glacierPolicyApiGetDentist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetDentistData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetDentistResponse,
    GlacierPolicyApiGetDentistError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}',
  });
};

/**
 * Set Dentist As First Named Insured
 * Set a dentist as the first named insured for the policy.
 * Expects a dentist ID in the request body.
 */
export const glacierPolicyApiSetDentistAsFirstNamedInsured = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiSetDentistAsFirstNamedInsuredData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiSetDentistAsFirstNamedInsuredResponse,
    GlacierPolicyApiSetDentistAsFirstNamedInsuredError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/dentist/set-dentist-as-first-named-insured/',
    responseTransformer:
      GlacierPolicyApiSetDentistAsFirstNamedInsuredResponseTransformer,
  });
};

/**
 * Set Owned Entity As First Named Insured
 * Set an owned entity as the first named insured for the policy.
 * Expects an owned entity ID in the request body.
 */
export const glacierPolicyApiSetOwnedEntityAsFirstNamedInsured = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredResponse,
    GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/owned-entity/set-owned-entity-as-first-named-insured/',
    responseTransformer:
      GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredResponseTransformer,
  });
};

/**
 * Add Dentist
 */
export const glacierPolicyApiAddDentist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiAddDentistData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiAddDentistResponse,
    GlacierPolicyApiAddDentistError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/dentist/',
  });
};

/**
 * Delete Dentist
 */
export const glacierPolicyApiDeleteDentist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDeleteDentistData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    GlacierPolicyApiDeleteDentistResponse,
    GlacierPolicyApiDeleteDentistError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/',
    responseTransformer: GlacierPolicyApiDeleteDentistResponseTransformer,
  });
};

/**
 * Update Basic Dentist
 */
export const glacierPolicyApiUpdateBasicDentist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateBasicDentistData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    GlacierPolicyApiUpdateBasicDentistResponse,
    GlacierPolicyApiUpdateBasicDentistError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/',
  });
};

/**
 * Undo Delete Dentist
 */
export const glacierPolicyApiUndoDeleteDentist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUndoDeleteDentistData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiUndoDeleteDentistResponse,
    GlacierPolicyApiUndoDeleteDentistError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/reinstate/',
    responseTransformer: GlacierPolicyApiUndoDeleteDentistResponseTransformer,
  });
};

/**
 * Update Dentist Information
 */
export const glacierPolicyApiUpdateDentistInformation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateDentistInformationData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    GlacierPolicyApiUpdateDentistInformationResponse,
    GlacierPolicyApiUpdateDentistInformationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/information/',
  });
};

/**
 * Get Dentist Information
 */
export const glacierPolicyApiGetDentistInformation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetDentistInformationData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetDentistInformationResponse,
    GlacierPolicyApiGetDentistInformationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/information/',
  });
};

/**
 * Update Dentist Pricing
 */
export const glacierPolicyApiUpdateDentistPricing = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateDentistPricingData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    GlacierPolicyApiUpdateDentistPricingResponse,
    GlacierPolicyApiUpdateDentistPricingError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/pricing/',
  });
};

/**
 * Get Dentist Pricing
 */
export const glacierPolicyApiGetDentistPricing = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetDentistPricingData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetDentistPricingResponse,
    GlacierPolicyApiGetDentistPricingError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/pricing/',
  });
};

/**
 * Update Dentist Procedures
 */
export const glacierPolicyApiUpdateDentistProcedures = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateDentistProceduresData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    GlacierPolicyApiUpdateDentistProceduresResponse,
    GlacierPolicyApiUpdateDentistProceduresError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/procedures/',
  });
};

/**
 * Get Dentist Procedures
 */
export const glacierPolicyApiGetDentistProcedures = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetDentistProceduresData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetDentistProceduresResponse,
    GlacierPolicyApiGetDentistProceduresError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/procedures/',
  });
};

/**
 * Update Pl Practice Owner
 */
export const glacierPolicyApiUpdatePlPracticeOwner = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdatePlPracticeOwnerData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    GlacierPolicyApiUpdatePlPracticeOwnerResponse,
    GlacierPolicyApiUpdatePlPracticeOwnerError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/pl/practice_owners/',
  });
};

/**
 * Get Practice Owners
 */
export const glacierPolicyApiGetPracticeOwners = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetPracticeOwnersData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetPracticeOwnersResponse,
    GlacierPolicyApiGetPracticeOwnersError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/pl/practice_owners/',
  });
};

/**
 * Update Pl Coverage
 */
export const glacierPolicyApiUpdatePlCoverage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdatePlCoverageData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    GlacierPolicyApiUpdatePlCoverageResponse,
    GlacierPolicyApiUpdatePlCoverageError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/pl/coverage/',
  });
};

/**
 * Get Pl Coverage
 */
export const glacierPolicyApiGetPlCoverage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetPlCoverageData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetPlCoverageResponse,
    GlacierPolicyApiGetPlCoverageError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/pl/coverage/',
  });
};

/**
 * Update Policy Details
 */
export const glacierPolicyApiUpdatePolicyDetails = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdatePolicyDetailsData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    GlacierPolicyApiUpdatePolicyDetailsResponse,
    GlacierPolicyApiUpdatePolicyDetailsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/details/',
  });
};

/**
 * Get Policy Details
 */
export const glacierPolicyApiGetPolicyDetails = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetPolicyDetailsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetPolicyDetailsResponse,
    GlacierPolicyApiGetPolicyDetailsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/details/',
  });
};

/**
 * Update Bypass Validators
 */
export const glacierPolicyApiUpdateBypassValidators = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateBypassValidatorsData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    GlacierPolicyApiUpdateBypassValidatorsResponse,
    GlacierPolicyApiUpdateBypassValidatorsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/bypass-validators/',
  });
};

/**
 * Refresh Commercial Property With Verisk
 */
export const glacierPolicyApiRefreshCommercialPropertyWithVerisk = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiRefreshCommercialPropertyWithVeriskData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiRefreshCommercialPropertyWithVeriskResponse,
    GlacierPolicyApiRefreshCommercialPropertyWithVeriskError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cp/locations/{location_id}/verisk',
  });
};

/**
 * Refresh Commercial Property With Corelogic
 */
export const glacierPolicyApiRefreshCommercialPropertyWithCorelogic = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiRefreshCommercialPropertyWithCorelogicData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiRefreshCommercialPropertyWithCorelogicResponse,
    GlacierPolicyApiRefreshCommercialPropertyWithCorelogicError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cp/locations/{location_id}/corelogic',
  });
};

/**
 * Add Commercial Property Coverage
 */
export const glacierPolicyApiAddCommercialPropertyCoverage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiAddCommercialPropertyCoverageData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiAddCommercialPropertyCoverageResponse,
    GlacierPolicyApiAddCommercialPropertyCoverageError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cp/locations/',
  });
};

/**
 * Update Commercial Property Coverage
 */
export const glacierPolicyApiUpdateCommercialPropertyCoverage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiUpdateCommercialPropertyCoverageData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).patch<
    GlacierPolicyApiUpdateCommercialPropertyCoverageResponse,
    GlacierPolicyApiUpdateCommercialPropertyCoverageError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cp/locations/{location_id}/',
  });
};

/**
 * Delete Commercial Property Coverage
 */
export const glacierPolicyApiDeleteCommercialPropertyCoverage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiDeleteCommercialPropertyCoverageData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).delete<
    GlacierPolicyApiDeleteCommercialPropertyCoverageResponse,
    GlacierPolicyApiDeleteCommercialPropertyCoverageError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cp/locations/{location_id}/',
  });
};

/**
 * Get Commercial Property Location
 */
export const glacierPolicyApiGetCommercialPropertyLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiGetCommercialPropertyLocationData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetCommercialPropertyLocationResponse,
    GlacierPolicyApiGetCommercialPropertyLocationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cp/locations/{location_id}/',
  });
};

/**
 * Undo Delete Commercial Property Coverage
 */
export const glacierPolicyApiUndoDeleteCommercialPropertyCoverage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiUndoDeleteCommercialPropertyCoverageData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiUndoDeleteCommercialPropertyCoverageResponse,
    GlacierPolicyApiUndoDeleteCommercialPropertyCoverageError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cp/locations/{location_id}/reinstate/',
  });
};

/**
 * Update Cp Coverage
 */
export const glacierPolicyApiUpdateCpCoverage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateCpCoverageData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    GlacierPolicyApiUpdateCpCoverageResponse,
    GlacierPolicyApiUpdateCpCoverageError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cp/coverage/',
  });
};

/**
 * Get Commercial Property Coverage
 */
export const glacierPolicyApiGetCommercialPropertyCoverage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiGetCommercialPropertyCoverageData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetCommercialPropertyCoverageResponse,
    GlacierPolicyApiGetCommercialPropertyCoverageError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cp/coverage/',
  });
};

/**
 * Rate Policy
 */
export const glacierPolicyApiRatePolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiRatePolicyData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiRatePolicyResponse,
    GlacierPolicyApiRatePolicyError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/rate/',
    responseTransformer: GlacierPolicyApiRatePolicyResponseTransformer,
  });
};

/**
 * Get Formulas
 */
export const glacierPolicyApiGetFormulas = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetFormulasData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetFormulasResponse,
    GlacierPolicyApiGetFormulasError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/formulas/',
    responseTransformer: GlacierPolicyApiGetFormulasResponseTransformer,
  });
};

/**
 * Create Owned Entities
 */
export const glacierPolicyApiCreateOwnedEntities = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiCreateOwnedEntitiesData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiCreateOwnedEntitiesResponse,
    GlacierPolicyApiCreateOwnedEntitiesError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/owned_entities/',
  });
};

/**
 * Get Owned Entity
 */
export const glacierPolicyApiGetOwnedEntity = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetOwnedEntityData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetOwnedEntityResponse,
    GlacierPolicyApiGetOwnedEntityError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/owned_entities/{entity_id}/',
  });
};

/**
 * Updated Owned Entity
 */
export const glacierPolicyApiUpdatedOwnedEntity = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdatedOwnedEntityData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    GlacierPolicyApiUpdatedOwnedEntityResponse,
    GlacierPolicyApiUpdatedOwnedEntityError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/owned_entities/{entity_id}/',
  });
};

/**
 * Delete Owned Entity
 */
export const glacierPolicyApiDeleteOwnedEntity = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDeleteOwnedEntityData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    GlacierPolicyApiDeleteOwnedEntityResponse,
    GlacierPolicyApiDeleteOwnedEntityError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/owned_entities/{entity_id}/',
    responseTransformer: GlacierPolicyApiDeleteOwnedEntityResponseTransformer,
  });
};

/**
 * Undo Delete Owned Entity
 */
export const glacierPolicyApiUndoDeleteOwnedEntity = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUndoDeleteOwnedEntityData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiUndoDeleteOwnedEntityResponse,
    GlacierPolicyApiUndoDeleteOwnedEntityError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/owned_entities/{entity_id}/reinstate/',
    responseTransformer:
      GlacierPolicyApiUndoDeleteOwnedEntityResponseTransformer,
  });
};

/**
 * Update General Liability
 */
export const glacierPolicyApiUpdateGeneralLiability = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateGeneralLiabilityData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    GlacierPolicyApiUpdateGeneralLiabilityResponse,
    GlacierPolicyApiUpdateGeneralLiabilityError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/general_liability/',
  });
};

/**
 * Update Employment Practices Liability
 */
export const glacierPolicyApiUpdateEmploymentPracticesLiability = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiUpdateEmploymentPracticesLiabilityData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).patch<
    GlacierPolicyApiUpdateEmploymentPracticesLiabilityResponse,
    GlacierPolicyApiUpdateEmploymentPracticesLiabilityError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/employment_practices_liability/',
  });
};

/**
 * Update Erisa And Employee Benefits
 */
export const glacierPolicyApiUpdateErisaAndEmployeeBenefits = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiUpdateErisaAndEmployeeBenefitsData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).patch<
    GlacierPolicyApiUpdateErisaAndEmployeeBenefitsResponse,
    GlacierPolicyApiUpdateErisaAndEmployeeBenefitsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/erisa_and_employee_benefits/',
  });
};

/**
 * Issue Policy
 */
export const glacierPolicyApiIssuePolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiIssuePolicyData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiIssuePolicyResponse,
    GlacierPolicyApiIssuePolicyError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/transactions/issue-policy/',
  });
};

/**
 * Get Agent Authority
 * Get the agent authority for the policy.
 */
export const glacierPolicyApiGetAgentAuthority = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetAgentAuthorityData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetAgentAuthorityResponse,
    GlacierPolicyApiGetAgentAuthorityError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/agent-authority/',
  });
};

/**
 * Create Midterm Transaction
 */
export const glacierPolicyApiCreateMidtermTransaction = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiCreateMidtermTransactionData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiCreateMidtermTransactionResponse,
    GlacierPolicyApiCreateMidtermTransactionError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/midterm-change/create/',
    responseTransformer:
      GlacierPolicyApiCreateMidtermTransactionResponseTransformer,
  });
};

/**
 * Set Reason For Change
 */
export const glacierPolicyApiSetReasonForChange = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiSetReasonForChangeData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiSetReasonForChangeResponse,
    GlacierPolicyApiSetReasonForChangeError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/midterm-change/set-reason-for-change/',
  });
};

/**
 * Price Preview Midterm Change
 */
export const glacierPolicyApiPricePreviewMidtermChange = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiPricePreviewMidtermChangeData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiPricePreviewMidtermChangeResponse,
    GlacierPolicyApiPricePreviewMidtermChangeError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/midterm-change/price-preview/',
    responseTransformer:
      GlacierPolicyApiPricePreviewMidtermChangeResponseTransformer,
  });
};

/**
 * Finalize Midterm Change
 */
export const glacierPolicyApiFinalizeMidtermChange = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiFinalizeMidtermChangeData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiFinalizeMidtermChangeResponse,
    GlacierPolicyApiFinalizeMidtermChangeError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/midterm-change/finalize/',
    responseTransformer:
      GlacierPolicyApiFinalizeMidtermChangeResponseTransformer,
  });
};

/**
 * Cancel Midterm Change
 */
export const glacierPolicyApiCancelMidtermChange = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiCancelMidtermChangeData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiCancelMidtermChangeResponse,
    GlacierPolicyApiCancelMidtermChangeError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/midterm-change/cancel/',
    responseTransformer: GlacierPolicyApiCancelMidtermChangeResponseTransformer,
  });
};

/**
 * Revert Transaction
 */
export const glacierPolicyApiRevertTransaction = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiRevertTransactionData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiRevertTransactionResponse,
    GlacierPolicyApiRevertTransactionError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/transactions/{number}/revert/',
    responseTransformer: GlacierPolicyApiRevertTransactionResponseTransformer,
  });
};

/**
 * Update Dentist Underwriting Questions
 */
export const glacierPolicyApiUpdateDentistUnderwritingQuestions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiUpdateDentistUnderwritingQuestionsData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).patch<
    GlacierPolicyApiUpdateDentistUnderwritingQuestionsResponse,
    GlacierPolicyApiUpdateDentistUnderwritingQuestionsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/dentist/{dentist_id}/underwriting_questions/',
  });
};

/**
 * Premium Statement
 */
export const glacierPolicyApiPremiumStatement = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiPremiumStatementData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiPremiumStatementResponse,
    GlacierPolicyApiPremiumStatementError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/documents/premium-statement/',
  });
};

/**
 * Get Special Forms
 */
export const glacierPolicyApiGetSpecialForms = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetSpecialFormsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiGetSpecialFormsResponse,
    GlacierPolicyApiGetSpecialFormsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/documents/special-forms/',
  });
};

/**
 * Conditional Renewal Notice
 */
export const glacierPolicyApiConditionalRenewalNotice = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiConditionalRenewalNoticeData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiConditionalRenewalNoticeResponse,
    GlacierPolicyApiConditionalRenewalNoticeError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/documents/renewal-notice/',
  });
};

/**
 * Download Rating Worksheets
 */
export const glacierPolicyApiDownloadRatingWorksheets = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDownloadRatingWorksheetsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiDownloadRatingWorksheetsResponse,
    GlacierPolicyApiDownloadRatingWorksheetsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/documents/rating_worksheets/{worksheet_enum}/',
  });
};

/**
 * Premium Renewal Notice
 */
export const glacierPolicyApiPremiumRenewalNotice = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiPremiumRenewalNoticeData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiPremiumRenewalNoticeResponse,
    GlacierPolicyApiPremiumRenewalNoticeError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/documents/premium-renewal-notice/',
  });
};

/**
 * Download Looker Dashboard Pdf
 */
export const glacierPolicyApiDownloadLookerDashboardPdf = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDownloadLookerDashboardPdfData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiDownloadLookerDashboardPdfResponse,
    GlacierPolicyApiDownloadLookerDashboardPdfError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/documents/looker_dashboard_pdf/',
  });
};

/**
 * Download Looker Dashboard Csv
 */
export const glacierPolicyApiDownloadLookerDashboardCsv = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDownloadLookerDashboardCsvData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiDownloadLookerDashboardCsvResponse,
    GlacierPolicyApiDownloadLookerDashboardCsvError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/documents/looker_dashboard_csv/',
  });
};

/**
 * Specimen Preview
 */
export const glacierPolicyApiSpecimenPreview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiSpecimenPreviewData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiSpecimenPreviewResponse,
    GlacierPolicyApiSpecimenPreviewError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/generate-preview/specimen/',
  });
};

/**
 * List Documents
 */
export const glacierPolicyApiListDocuments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiListDocumentsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiListDocumentsResponse,
    GlacierPolicyApiListDocumentsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/documents/',
    responseTransformer: GlacierPolicyApiListDocumentsResponseTransformer,
  });
};

/**
 * Upload Document
 */
export const glacierPolicyApiUploadDocument = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUploadDocumentData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiUploadDocumentResponse,
    GlacierPolicyApiUploadDocumentError,
    ThrowOnError
  >({
    ...options,
    ...formDataBodySerializer,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
    url: '/api/v1/policy/{account_id}/documents/',
  });
};

/**
 * Detach Document
 */
export const glacierPolicyApiDetachDocument = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDetachDocumentData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    GlacierPolicyApiDetachDocumentResponse,
    GlacierPolicyApiDetachDocumentError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/documents/{document_id}/',
  });
};

/**
 * Update Document
 */
export const glacierPolicyApiUpdateDocument = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateDocumentData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    GlacierPolicyApiUpdateDocumentResponse,
    GlacierPolicyApiUpdateDocumentError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/documents/{document_id}/',
  });
};

/**
 * Document Is Ready
 * Check if a document is already rendered
 * Returns status 200 with status 200 if the document is ready, 404 with status 404 if it is not.
 */
export const documentIsReady = <ThrowOnError extends boolean = false>(
  options: Options<DocumentIsReadyData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    DocumentIsReadyResponse,
    DocumentIsReadyError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/document-warehouse/{document_id}/is-ready/',
  });
};

/**
 * Download Document
 */
export const glacierPolicyApiDownloadDocument = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDownloadDocumentData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiDownloadDocumentResponse,
    GlacierPolicyApiDownloadDocumentError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/document-warehouse/{document_id}/{policy_id}/download/',
  });
};

/**
 * Regenerate Document
 */
export const glacierPolicyApiRegenerateDocument = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiRegenerateDocumentData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiRegenerateDocumentResponse,
    GlacierPolicyApiRegenerateDocumentError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/document-warehouse/{document_id}/{policy_id}/regenerate/',
  });
};

/**
 * Commit Transaction Test
 */
export const glacierPolicyApiCommitTransactionTest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiCommitTransactionTestData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiCommitTransactionTestResponse,
    GlacierPolicyApiCommitTransactionTestError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/commit_transaction_test/',
  });
};

/**
 * List Underwriter Notes
 */
export const glacierPolicyApiListUnderwriterNotes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiListUnderwriterNotesData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiListUnderwriterNotesResponse,
    GlacierPolicyApiListUnderwriterNotesError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/underwriter-notes/',
    responseTransformer:
      GlacierPolicyApiListUnderwriterNotesResponseTransformer,
  });
};

/**
 * Create Underwriter Notes
 */
export const glacierPolicyApiCreateUnderwriterNotes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiCreateUnderwriterNotesData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiCreateUnderwriterNotesResponse,
    GlacierPolicyApiCreateUnderwriterNotesError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/underwriter-notes/',
    responseTransformer:
      GlacierPolicyApiCreateUnderwriterNotesResponseTransformer,
  });
};

/**
 * Update Underwriter Notes
 */
export const glacierPolicyApiUpdateUnderwriterNotes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiUpdateUnderwriterNotesData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    GlacierPolicyApiUpdateUnderwriterNotesResponse,
    GlacierPolicyApiUpdateUnderwriterNotesError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/underwriter-notes/{note_id}/',
    responseTransformer:
      GlacierPolicyApiUpdateUnderwriterNotesResponseTransformer,
  });
};

/**
 * Delete Underwriter Notes
 */
export const glacierPolicyApiDeleteUnderwriterNotes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiDeleteUnderwriterNotesData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    GlacierPolicyApiDeleteUnderwriterNotesResponse,
    GlacierPolicyApiDeleteUnderwriterNotesError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/underwriter-notes/{note_id}/',
  });
};

/**
 * Reopen Unlocked Account
 * Endpoint to reopen an unlocked account for system admin users.
 * Sets quote_type back to None and erases the policy_number.
 */
export const glacierPolicyApiReopenUnlockedAccount = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiReopenUnlockedAccountData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiReopenUnlockedAccountResponse,
    GlacierPolicyApiReopenUnlockedAccountError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/reopen_unlocked_account/',
  });
};

/**
 * Create Policy Pending Cancellation Transaction
 */
export const glacierPolicyApiCreatePolicyPendingCancellationTransaction = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyApiCreatePolicyPendingCancellationTransactionData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponse,
    GlacierPolicyApiCreatePolicyPendingCancellationTransactionError,
    ThrowOnError
  >({
    ...options,
    ...formDataBodySerializer,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
    url: '/api/v1/policy/{account_id}/midterm-change/pending-cancellation-policy/',
    responseTransformer:
      GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponseTransformer,
  });
};

/**
 * List Object Summaries
 */
export const glacierPolicyApiListObjectSummaries = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiListObjectSummariesData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiListObjectSummariesResponse,
    GlacierPolicyApiListObjectSummariesError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/object-summaries/{object_type}/',
  });
};

/**
 * Get Object Details
 */
export const glacierPolicyApiGetObjectDetails = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetObjectDetailsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetObjectDetailsResponse,
    GlacierPolicyApiGetObjectDetailsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/object-details/{object_type}/{object_id}/',
  });
};

/**
 * Refer Policy
 */
export const glacierPolicyApiReferPolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiReferPolicyData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyApiReferPolicyResponse,
    GlacierPolicyApiReferPolicyError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/refer/',
  });
};

/**
 * List Transactions
 * Get all transaction snapshots for a policy for Time Travel functionality.
 * Each snapshot represents the final state of a transaction that users can navigate to.
 * Returns snapshots ordered by transaction number (newest first).
 */
export const glacierPolicyApiListTransactions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiListTransactionsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiListTransactionsResponse,
    GlacierPolicyApiListTransactionsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/transactions/',
    responseTransformer: GlacierPolicyApiListTransactionsResponseTransformer,
  });
};

/**
 * Get Transaction Detail
 * Get transaction detail for Time Travel functionality.
 * Returns transaction details and assigned user information.
 * This allows users to view the transaction details for a specific transaction number.
 * Unlike other endpoints, this one always uses the transaction_number from the URL parameter,
 * not from request headers.
 */
export const glacierPolicyApiGetTransactionDetail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyApiGetTransactionDetailData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyApiGetTransactionDetailResponse,
    GlacierPolicyApiGetTransactionDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/transaction-detail/{transaction_number}/',
    responseTransformer:
      GlacierPolicyApiGetTransactionDetailResponseTransformer,
  });
};

/**
 * Policy Level Attached Endorsements
 * Return all the attached endorsements at the policy level
 */
export const glacierPolicyFormsApiPolicyLevelAttachedEndorsements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsResponse,
    GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/policy/attached-forms/',
  });
};

/**
 * Attach Form To Policy
 */
export const glacierPolicyFormsApiAttachFormToPolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiAttachFormToPolicyData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyFormsApiAttachFormToPolicyResponse,
    GlacierPolicyFormsApiAttachFormToPolicyError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/policy/attach-form/',
    responseTransformer:
      GlacierPolicyFormsApiAttachFormToPolicyResponseTransformer,
  });
};

/**
 * Detach Form From Policy
 */
export const glacierPolicyFormsApiDetachFormFromPolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiDetachFormFromPolicyData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyFormsApiDetachFormFromPolicyResponse,
    GlacierPolicyFormsApiDetachFormFromPolicyError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/policy/detach-form/',
  });
};

/**
 * Get Available Endorsements
 */
export const glacierPolicyFormsApiGetAvailableEndorsements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiGetAvailableEndorsementsData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GlacierPolicyFormsApiGetAvailableEndorsementsResponse,
    GlacierPolicyFormsApiGetAvailableEndorsementsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/policy/available-endorsements/',
  });
};

/**
 * Attach Form To Dentist
 */
export const glacierPolicyFormsApiAttachFormToDentist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiAttachFormToDentistData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyFormsApiAttachFormToDentistResponse,
    GlacierPolicyFormsApiAttachFormToDentistError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/dentist/{dentist_id}/attach-form/',
  });
};

/**
 * Detach Form From Dentist
 */
export const glacierPolicyFormsApiDetachFormFromDentist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiDetachFormFromDentistData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyFormsApiDetachFormFromDentistResponse,
    GlacierPolicyFormsApiDetachFormFromDentistError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/dentist/{dentist_id}/detach-form/',
  });
};

/**
 * Get Dentist Attached Forms
 */
export const glacierPolicyFormsApiGetDentistAttachedForms = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiGetDentistAttachedFormsData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GlacierPolicyFormsApiGetDentistAttachedFormsResponse,
    GlacierPolicyFormsApiGetDentistAttachedFormsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/dentist/{dentist_id}/attached-forms/',
  });
};

/**
 * Get Dentist Available Endorsements
 */
export const glacierPolicyFormsApiGetDentistAvailableEndorsements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiGetDentistAvailableEndorsementsData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GlacierPolicyFormsApiGetDentistAvailableEndorsementsResponse,
    GlacierPolicyFormsApiGetDentistAvailableEndorsementsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/dentist/{dentist_id}/available-endorsements/',
  });
};

/**
 * Attach Form To Location
 */
export const glacierPolicyFormsApiAttachFormToLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiAttachFormToLocationData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyFormsApiAttachFormToLocationResponse,
    GlacierPolicyFormsApiAttachFormToLocationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/location/{location_id}/attach-form/',
  });
};

/**
 * Detach Form From Location
 */
export const glacierPolicyFormsApiDetachFormFromLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiDetachFormFromLocationData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    GlacierPolicyFormsApiDetachFormFromLocationResponse,
    GlacierPolicyFormsApiDetachFormFromLocationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/location/{location_id}/detach-form/',
  });
};

/**
 * Get Location Attached Forms
 */
export const glacierPolicyFormsApiGetLocationAttachedForms = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiGetLocationAttachedFormsData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GlacierPolicyFormsApiGetLocationAttachedFormsResponse,
    GlacierPolicyFormsApiGetLocationAttachedFormsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/location/{location_id}/attached-forms/',
  });
};

/**
 * Get Location Available Endorsements
 */
export const glacierPolicyFormsApiGetLocationAvailableEndorsements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiGetLocationAvailableEndorsementsData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GlacierPolicyFormsApiGetLocationAvailableEndorsementsResponse,
    GlacierPolicyFormsApiGetLocationAvailableEndorsementsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/location/{location_id}/available-endorsements/',
  });
};

/**
 * Attach Form To Entity
 */
export const glacierPolicyFormsApiAttachFormToEntity = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiAttachFormToEntityData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyFormsApiAttachFormToEntityResponse,
    GlacierPolicyFormsApiAttachFormToEntityError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/entity/{entity_id}/attach-form/',
  });
};

/**
 * Detach Form From Entity
 */
export const glacierPolicyFormsApiDetachFormFromEntity = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiDetachFormFromEntityData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyFormsApiDetachFormFromEntityResponse,
    GlacierPolicyFormsApiDetachFormFromEntityError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/entity/{entity_id}/detach-form/',
  });
};

/**
 * Get Entity Attached Forms
 */
export const glacierPolicyFormsApiGetEntityAttachedForms = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiGetEntityAttachedFormsData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GlacierPolicyFormsApiGetEntityAttachedFormsResponse,
    GlacierPolicyFormsApiGetEntityAttachedFormsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/entity/{entity_id}/attached-forms/',
  });
};

/**
 * Get Entity Available Endorsements
 */
export const glacierPolicyFormsApiGetEntityAvailableEndorsements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiGetEntityAvailableEndorsementsData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GlacierPolicyFormsApiGetEntityAvailableEndorsementsResponse,
    GlacierPolicyFormsApiGetEntityAvailableEndorsementsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/entity/{entity_id}/available-endorsements/',
  });
};

/**
 * Render Form
 * Render a form to PDF
 *
 * If a sequence_id is provided here outside of time travel mode,
 * it will load the policy version from the repository.
 */
export const glacierPolicyFormsApiRenderForm = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiRenderFormData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyFormsApiRenderFormResponse,
    GlacierPolicyFormsApiRenderFormError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/render-form/',
  });
};

/**
 * Get Questions By Policy
 */
export const glacierPolicyFormsApiGetQuestionsByPolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiGetQuestionsByPolicyData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyFormsApiGetQuestionsByPolicyResponse,
    GlacierPolicyFormsApiGetQuestionsByPolicyError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/policy/attached-forms/{attached_form_id}/questions/',
    responseTransformer:
      GlacierPolicyFormsApiGetQuestionsByPolicyResponseTransformer,
  });
};

/**
 * Post Save Questions Answers Policy
 */
export const glacierPolicyFormsApiPostSaveQuestionsAnswersPolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyResponse,
    GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/policy/attached-forms/{attached_form_id}/questions/',
  });
};

/**
 * Get Questions By Dentist
 */
export const glacierPolicyFormsApiGetQuestionsByDentist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiGetQuestionsByDentistData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyFormsApiGetQuestionsByDentistResponse,
    GlacierPolicyFormsApiGetQuestionsByDentistError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/dentist/{dentist_id}/attached-forms/{attached_form_id}/questions/',
    responseTransformer:
      GlacierPolicyFormsApiGetQuestionsByDentistResponseTransformer,
  });
};

/**
 * Post Save Questions Answers Dentist
 */
export const glacierPolicyFormsApiPostSaveQuestionsAnswersDentist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistResponse,
    GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/dentist/{dentist_id}/attached-forms/{attached_form_id}/questions/',
  });
};

/**
 * Get Questions By Location
 */
export const glacierPolicyFormsApiGetQuestionsByLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiGetQuestionsByLocationData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GlacierPolicyFormsApiGetQuestionsByLocationResponse,
    GlacierPolicyFormsApiGetQuestionsByLocationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/location/{location_id}/attached-forms/{attached_form_id}/questions/',
    responseTransformer:
      GlacierPolicyFormsApiGetQuestionsByLocationResponseTransformer,
  });
};

/**
 * Post Save Questions Answers Location
 */
export const glacierPolicyFormsApiPostSaveQuestionsAnswersLocation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationResponse,
    GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/location/{location_id}/attached-forms/{attached_form_id}/questions/',
  });
};

/**
 * Get Questions By Entity
 */
export const glacierPolicyFormsApiGetQuestionsByEntity = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyFormsApiGetQuestionsByEntityData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyFormsApiGetQuestionsByEntityResponse,
    GlacierPolicyFormsApiGetQuestionsByEntityError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/entity/{entity_id}/attached-forms/{attached_form_id}/questions/',
    responseTransformer:
      GlacierPolicyFormsApiGetQuestionsByEntityResponseTransformer,
  });
};

/**
 * Post Save Questions Answers Entity
 */
export const glacierPolicyFormsApiPostSaveQuestionsAnswersEntity = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityResponse,
    GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/cms-forms/entity/{entity_id}/attached-forms/{attached_form_id}/questions/',
  });
};

/**
 * List Binding Conditions
 */
export const glacierPolicyConditionsApiListBindingConditions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyConditionsApiListBindingConditionsData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GlacierPolicyConditionsApiListBindingConditionsResponse,
    GlacierPolicyConditionsApiListBindingConditionsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/binding-conditions/',
    responseTransformer:
      GlacierPolicyConditionsApiListBindingConditionsResponseTransformer,
  });
};

/**
 * Create Binding Condition
 */
export const glacierPolicyConditionsApiCreateBindingCondition = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyConditionsApiCreateBindingConditionData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    GlacierPolicyConditionsApiCreateBindingConditionResponse,
    GlacierPolicyConditionsApiCreateBindingConditionError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/binding-conditions/',
    responseTransformer:
      GlacierPolicyConditionsApiCreateBindingConditionResponseTransformer,
  });
};

/**
 * Update Binding Condition
 */
export const glacierPolicyConditionsApiUpdateBindingCondition = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyConditionsApiUpdateBindingConditionData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).patch<
    GlacierPolicyConditionsApiUpdateBindingConditionResponse,
    GlacierPolicyConditionsApiUpdateBindingConditionError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/binding-conditions/{condition_id}/',
    responseTransformer:
      GlacierPolicyConditionsApiUpdateBindingConditionResponseTransformer,
  });
};

/**
 * Delete Binding Condition
 */
export const glacierPolicyConditionsApiDeleteBindingCondition = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyConditionsApiDeleteBindingConditionData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).delete<
    GlacierPolicyConditionsApiDeleteBindingConditionResponse,
    GlacierPolicyConditionsApiDeleteBindingConditionError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/binding-conditions/{condition_id}/',
  });
};

/**
 * List Terms Conditions
 */
export const glacierPolicyConditionsApiListTermsConditions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyConditionsApiListTermsConditionsData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GlacierPolicyConditionsApiListTermsConditionsResponse,
    GlacierPolicyConditionsApiListTermsConditionsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/terms-conditions/',
    responseTransformer:
      GlacierPolicyConditionsApiListTermsConditionsResponseTransformer,
  });
};

/**
 * Create Terms Condition
 */
export const glacierPolicyConditionsApiCreateTermsCondition = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyConditionsApiCreateTermsConditionData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    GlacierPolicyConditionsApiCreateTermsConditionResponse,
    GlacierPolicyConditionsApiCreateTermsConditionError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/terms-conditions/',
    responseTransformer:
      GlacierPolicyConditionsApiCreateTermsConditionResponseTransformer,
  });
};

/**
 * Update Terms Condition
 */
export const glacierPolicyConditionsApiUpdateTermsCondition = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyConditionsApiUpdateTermsConditionData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).patch<
    GlacierPolicyConditionsApiUpdateTermsConditionResponse,
    GlacierPolicyConditionsApiUpdateTermsConditionError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/terms-conditions/{term_id}/',
    responseTransformer:
      GlacierPolicyConditionsApiUpdateTermsConditionResponseTransformer,
  });
};

/**
 * Delete Terms Condition
 */
export const glacierPolicyConditionsApiDeleteTermsCondition = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GlacierPolicyConditionsApiDeleteTermsConditionData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).delete<
    GlacierPolicyConditionsApiDeleteTermsConditionResponse,
    GlacierPolicyConditionsApiDeleteTermsConditionError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{account_id}/terms-conditions/{term_id}/',
  });
};

/**
 * Get Erp Eligible Dates
 * Return Valid Effective Dates for ERP (Extended Reporting Period)
 */
export const glacierPolicyErpApiGetErpEligibleDates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyErpApiGetErpEligibleDatesData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyErpApiGetErpEligibleDatesResponse,
    GlacierPolicyErpApiGetErpEligibleDatesError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{policy_id}/erp/eligible-dates',
  });
};

/**
 * Get Erp Sections
 * Returns an array of ErpSection objects for the policy's active ERP In Progress transaction.
 */
export const glacierPolicyErpApiGetErpSections = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyErpApiGetErpSectionsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierPolicyErpApiGetErpSectionsResponse,
    GlacierPolicyErpApiGetErpSectionsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{policy_id}/erp/sections',
    responseTransformer: GlacierPolicyErpApiGetErpSectionsResponseTransformer,
  });
};

/**
 * Start Erp Endorsement
 * Start ERP Endorsement Transaction
 */
export const glacierPolicyErpApiStartErpEndorsement = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyErpApiStartErpEndorsementData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyErpApiStartErpEndorsementResponse,
    GlacierPolicyErpApiStartErpEndorsementError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{policy_id}/erp/start',
    responseTransformer:
      GlacierPolicyErpApiStartErpEndorsementResponseTransformer,
  });
};

/**
 * Save Erp Selections
 * Save ERP selections for the policy's active ERP In Progress transaction.
 */
export const glacierPolicyErpApiSaveErpSelections = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierPolicyErpApiSaveErpSelectionsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierPolicyErpApiSaveErpSelectionsResponse,
    GlacierPolicyErpApiSaveErpSelectionsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/policy/{policy_id}/erp/save',
    responseTransformer:
      GlacierPolicyErpApiSaveErpSelectionsResponseTransformer,
  });
};

/**
 * Get Jwt Token
 * OneSchema requires use of JWT tokens for requests. This returns a token that
 * the frontend can use when initializing the Importer.
 *
 * https://docs.oneschema.co/docs/generating-jwts
 */
export const glacierOneschemaApiGetJwtToken = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierOneschemaApiGetJwtTokenResponse,
    GlacierOneschemaApiGetJwtTokenError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/bulk/token/',
  });
};

/**
 * Bulk Upload Policies
 */
export const glacierOneschemaApiBulkUploadPolicies = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierOneschemaApiBulkUploadPoliciesData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierOneschemaApiBulkUploadPoliciesResponse,
    GlacierOneschemaApiBulkUploadPoliciesError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/bulk/policies/',
  });
};

/**
 * Bulk Upload Dentists
 * Performs a bulk import via data passed by OneSchema. The import
 * is controlled by the template key provided in the payload
 */
export const glacierOneschemaApiBulkUploadDentists = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierOneschemaApiBulkUploadDentistsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierOneschemaApiBulkUploadDentistsResponse,
    GlacierOneschemaApiBulkUploadDentistsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/bulk/dentists/',
  });
};

/**
 * Bulk Upload Locations
 * Performs a bulk import via data passed by OneSchema. The import
 * is controlled by the template key provided in the payload
 */
export const glacierOneschemaApiBulkUploadLocations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierOneschemaApiBulkUploadLocationsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierOneschemaApiBulkUploadLocationsResponse,
    GlacierOneschemaApiBulkUploadLocationsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/bulk/locations/',
  });
};

/**
 * List Writing Company
 * List writing company details
 */
export const glacierAgenciesApiListWritingCompany = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierAgenciesApiListWritingCompanyResponse,
    GlacierAgenciesApiListWritingCompanyError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/writing-company/',
  });
};

/**
 * Validate Agency
 * Validate the agency.
 */
export const glacierNewGradApiValidateAgency = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierNewGradApiValidateAgencyData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierNewGradApiValidateAgencyResponse,
    GlacierNewGradApiValidateAgencyError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/new-grad/validate-agency',
  });
};

/**
 * Save Answers
 * Save the answers.
 */
export const glacierNewGradApiSaveAnswers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierNewGradApiSaveAnswersData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierNewGradApiSaveAnswersResponse,
    GlacierNewGradApiSaveAnswersError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/new-grad/answers',
    responseTransformer: GlacierNewGradApiSaveAnswersResponseTransformer,
  });
};

/**
 * Get Answers
 * Get the answers.
 */
export const glacierNewGradApiGetAnswers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierNewGradApiGetAnswersData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GlacierNewGradApiGetAnswersResponse,
    GlacierNewGradApiGetAnswersError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/new-grad/answers/{account_id}',
    responseTransformer: GlacierNewGradApiGetAnswersResponseTransformer,
  });
};

/**
 * Poll Payment
 * Poll the payment status.
 */
export const glacierNewGradApiPollPayment = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierNewGradApiPollPaymentData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierNewGradApiPollPaymentResponse,
    GlacierNewGradApiPollPaymentError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/new-grad/{account_id}/poll',
  });
};

/**
 * Download Quote
 * Download the quote.
 */
export const glacierNewGradApiDownloadQuote = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierNewGradApiDownloadQuoteData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierNewGradApiDownloadQuoteResponse,
    GlacierNewGradApiDownloadQuoteError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/new-grad/{account_id}/quote',
  });
};

/**
 * Download Policy
 * Download the policy.
 */
export const glacierNewGradApiDownloadPolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GlacierNewGradApiDownloadPolicyData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GlacierNewGradApiDownloadPolicyResponse,
    GlacierNewGradApiDownloadPolicyError,
    ThrowOnError
  >({
    ...options,
    url: '/api/v1/new-grad/{account_id}/policy',
  });
};
